'use client'

import * as React from 'react'

import { getStaticAssetUrl } from '@helper/utils/file'
import cn from '@config/tailwind/cn'

export interface RewardStarProps {
  stars: 0 | 1 | 2 | 3
  className?: string
  middleClassName?: string
}

const STAR_INDICES = [0, 1, 2] as const

export function RewardStar({ stars, className, middleClassName }: RewardStarProps) {
  return (
    <div className={cn('srd:flex srd:items-end srd:w-full', className)}>
      {STAR_INDICES.map((index) => {
        const isFilled = index < stars
        const isMiddle = index === 1
        return (
          <img
            key={index}
            src={
              isFilled
                ? getStaticAssetUrl('illustration/star-xp/shine.png')
                : getStaticAssetUrl('illustration/star-xp/sleep.png')
            }
            alt={isFilled ? 'star' : 'empty star'}
            draggable={false}
            className={cn(
              'srd:w-1/3 srd:h-auto',
              isMiddle && 'srd:-translate-y-4 srd:scale-110',
              isMiddle && middleClassName,
            )}
          />
        )
      })}
    </div>
  )
}
